module.exports = __webpack_public_path__ + "static/what-50d7d0c218d18abad1427d0d9cf5bf12.gif";